import {NgModule} from '@angular/core';
import {SidebarPartial} from '../directives/layout/sidebar/sidebar-partial';
import {HeaderPartial} from '../directives/layout/header/header-partial';
import {FooterPartial} from '../directives/layout/footer/footer-partial';
import {LogoPartial} from '../directives/layout/logo/logo-partial';

@NgModule({
  imports: [
    SidebarPartial,
    HeaderPartial,
    FooterPartial,
    LogoPartial,
  ],
  exports: [
    SidebarPartial,
    HeaderPartial,
    FooterPartial,
    LogoPartial,
  ],
  providers: [
  ]
})
export class LayoutModule {
}
